import { ref, set } from "firebase/database";
import moment from "moment";

import realtimeDB from "./firebase";

/**
 * Báo nhanh cho phía bên kia về lời thách đấu Swiss.
 *
 * Backend không nói chuyện với Firebase, nên máy của người vừa thao tác tự ghi —
 * đúng lối các màn bắt kèo cũ vẫn làm. Vì thế đây chỉ là đường báo NHANH, không
 * phải nguồn sự thật: mất mạng, hoặc người nhận đang đóng app, thì tin này rơi.
 *
 * Nguồn sự thật là league_matches.challengeInitiatorId. Mọi trạng thái ở đây đều
 * đọc lại được từ tab Thi đấu của giải, nên hỏng đường này không mất gì ngoài
 * việc phải mở lại trang. Cũng vì thế mọi lỗi ở đây đều nuốt: không được để một
 * lần ghi Firebase hỏng chặn luồng của người dùng.
 */

const write = async (playerId: string, payload: Record<string, unknown>) => {
  try {
    await set(ref(realtimeDB, `swiss-challenges/${playerId}`), {
      ...payload,
      at: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
  } catch (e) {
    // Xem chú thích đầu file.
  }
};

/** "Tôi vừa quét mã của bạn" — người nhận sẽ thấy hộp thoại xác nhận. */
export const pingChallengeInvite = (
  opponentId: string,
  data: { challengerId: string; challengerName: string; leagueId: string; leagueName: string }
) => write(opponentId, { type: "invite", ...data });

/** "Tôi đã từ chối lời mời của bạn" — người mời khỏi ngồi chờ. */
export const pingChallengeDeclined = (opponentId: string, leagueId: string, byName: string) =>
  write(opponentId, { type: "declined", leagueId, declinedByName: byName || "Đối thủ" });
